<div class="p-6 space-y-6 bg-light">
  <section *ngIf="!loading" class="bg-white overflow-hidden rounded-t-md">
    <div class="relative w-full h-20 mb-4">
      <img
        [src]="companyBanner()"
        alt="Banner"
        class="w-full h-full object-cover"
      />
      <div class="absolute inset-0 opacity-50 bg-black"></div>
      <div class="absolute -bottom-8 left-10 flex justify-center items-center">
        <img
          [src]="jobDetail?.company?.urlBannerMiniPage"
          alt="Logo"
          class="w-16 h-16 object-cover rounded"
        />
      </div>
    </div>
    <div class="mt-14 px-6">
      <h1 class="text-2xl font-bold">{{ jobDetail?.title }}</h1>
      <div class="flex justify-between items-center mt-2">
        <div class="flex items-center gap-4">
          <p class="text-gray-500">{{ jobDetail?.company?.commercialName }}</p>
          <ng-container *ngIf="!isVerified(); else verifiedBlock">
            <div class="flex items-center text-yellow-600 font-medium">
              <ng-icon name="heroInformationCircle" size="20"></ng-icon>
              <p class="text-sm hover:underline ml-2 cursor-pointer">
                No verificado
              </p>
            </div>
          </ng-container>
          <ng-template #verifiedBlock>
            <div
              class="flex items-center rounded-full mt-1 text-green-800 bg-green-100 p-2 px-5 font-medium relative group cursor-pointer"
            >
              <ng-icon name="heroCheckBadge" size="20"></ng-icon>
              <p class="text-sm ml-2">Compañía verificada</p>
              <span
                class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-3 py-0 rounded text-xs text-white bg-gray-800 opacity-0 group-hover:opacity-100 transition whitespace-nowrap"
              >
                Compañía verificada por Codideep
              </span>
            </div>
          </ng-template>
          @if (jobDetail?.publicationStatus === 'Finalizado') {
          <span
            class="bg-red-100 text-red-600 text-xs font-semibold px-3 py-1 rounded-full shadow-sm"
          >
            Oferta de empleo finalizada
          </span>
          }
        </div>
        <app-nav-button [route]="'/my-jobs'"></app-nav-button>
      </div>
    </div>
    <div
      class="flex justify-between items-center flex-wrap gap-4 px-6 pb-4 text-sm text-gray-600 mt-5"
    >
      <div class="flex gap-4">
        <p>
          <i class="fa-solid fa-location-dot"></i>
          {{ jobDetail?.company?.district }}
        </p>
        <p>|</p>
        <p>
          <i class="fa-regular fa-clock"></i>
          {{ jobDetail?.publicationDate | timeAgo }}
        </p>
      </div>
    </div>
  </section>
  <section
    *ngIf="loading"
    class="bg-white overflow-hidden rounded-t-md animate-pulse"
  >
    <div class="relative w-full h-20 mb-4 bg-gray-200"></div>
    <div class="mt-14 px-6 space-y-2">
      <div class="h-6 w-3/4 bg-gray-200 rounded"></div>
      <div class="h-4 w-1/2 bg-gray-300 rounded"></div>
    </div>
    <div
      class="flex justify-between items-center flex-wrap gap-4 px-6 pb-4 mt-4"
    >
      <div class="flex gap-4">
        <div class="h-4 w-24 bg-gray-200 rounded"></div>
        <div class="h-4 w-6 bg-gray-300 rounded"></div>
        <div class="h-4 w-32 bg-gray-200 rounded"></div>
      </div>
    </div>
  </section>
  <section
    *ngIf="!loading"
    class="bg-white rounded-b-lg grid min-h-[500px] grid-cols-1 md:grid-cols-[60%_40%] border-t border-gray-200"
  >
    <div class="p-6 space-y-6">
      <div class="grid grid-cols-1 mt-5 sm:grid-cols-2 gap-6 text-sm">
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionMailOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <span>{{ jobDetail?.company?.email }}</span>
            <p class="text-sm text-gray-600">Email</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionBusinessOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <span>{{ jobDetail?.company?.businessLine }}</span>
            <p class="text-sm text-gray-600">Área</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionTimerOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <span>{{ jobDetail?.type }}</span>
            <p class="text-sm text-gray-600">Tipo</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionPersonOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <span>{{ jobDetail?.recluter?.name }}</span>
            <p class="text-sm text-gray-600">Reclutador</p>
          </div>
        </div>
      </div>
      <hr class="border-gray-100" />
      <section class="space-y-4">
        <h2 class="text-xl font-semibold">Descripción</h2>
        <div
          [innerHTML]="jobDetail?.description"
          class="custom-editor text-gray-700"
        ></div>
      </section>
    </div>
    <div class="p-6 border-l border-gray-200">
      <h2 class="text-lg font-semibold mb-8">Estado de tu postulación</h2>
      <div class="relative">
        <div class="relative mb-12 pl-10 sm:pl-16">
          <div
            class="absolute left-5 top-8 h-full border-l-2"
            [ngClass]="isLineActive(1) ? 'border-primary' : 'border-gray-200'"
          ></div>
          <div
            class="absolute left-0 top-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm sm:text-base"
            [ngClass]="
              isStepActive(1) ? 'bg-primary' : 'bg-gray-300 text-gray-600'
            "
          >
            1
          </div>
          <h3 class="font-medium text-base sm:text-lg">
            {{ postulantSteps.enviado.title }}
          </h3>
          <p class="text-sm text-gray-500 mt-1 sm:mt-2">
            {{
              postulantSteps.enviado.getDescription(
                postulantDetail?.registrationDate
              )
            }}
          </p>
        </div>
        <div class="relative mb-12 pl-10 sm:pl-16">
          <div
            class="absolute left-5 top-8 h-full border-l-2"
            [ngClass]="isLineActive(2) ? 'border-primary' : 'border-gray-200'"
          ></div>
          <div
            class="absolute left-0 top-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm sm:text-base"
            [ngClass]="
              isStepActive(2) ? 'bg-primary' : 'bg-gray-300 text-gray-600'
            "
          >
            2
          </div>
          <h3 class="font-medium text-base sm:text-lg">
            {{ postulantSteps.revisado.title }}
          </h3>
          <p class="text-sm text-gray-500 mt-1 sm:mt-2">
            {{
              postulantSteps.revisado.getDescription(
                postulantDetail?.statusProcess
              )
            }}
          </p>
        </div>
        <div class="relative mb-12 pl-10 sm:pl-16">
          <div
            class="absolute left-5 top-8 h-full border-l-2"
            [ngClass]="isLineActive(3) ? 'border-primary' : 'border-gray-200'"
          ></div>
          <div
            class="absolute left-0 top-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm sm:text-base"
            [ngClass]="
              isStepActive(3) ? 'bg-primary' : 'bg-gray-300 text-gray-600'
            "
          >
            3
          </div>
          <h3 class="font-medium text-base sm:text-lg">
            {{ postulantSteps.preseleccionado.title }}
          </h3>
          <p class="text-sm text-gray-500 mt-1 sm:mt-2">
            {{
              postulantSteps.preseleccionado.getDescription(
                postulantDetail?.statusProcess
              )
            }}
          </p>
        </div>
        <div class="relative mb-0 pl-10 sm:pl-16">
          <div
            class="absolute left-0 top-0 w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm sm:text-base"
            [ngClass]="
              isStepActive(4) ? 'bg-primary' : 'bg-gray-300 text-gray-600'
            "
          >
            4
          </div>
          <h3 class="font-medium text-base sm:text-lg">
            {{ postulantSteps.seleccionado.title }}
          </h3>
          <p class="text-sm text-gray-500 mt-1 sm:mt-2">
            {{
              postulantSteps.seleccionado.getDescription(
                postulantDetail?.statusProcess
              )
            }}
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    *ngIf="loading"
    class="bg-white rounded-b-lg grid min-h-[500px] grid-cols-1 md:grid-cols-[60%_40%] border-t border-gray-200"
  >
    <div *ngIf="loading" class="p-6 space-y-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-5">
        <div class="h-12 bg-gray-200 rounded"></div>
        <div class="h-12 bg-gray-200 rounded"></div>
        <div class="h-12 bg-gray-200 rounded"></div>
        <div class="h-12 bg-gray-200 rounded"></div>
      </div>
      <div class="space-y-2 mt-4">
        <div class="h-6 w-32 bg-gray-200 rounded"></div>
        <div class="space-y-2">
          <div class="h-4 w-full bg-gray-200 rounded"></div>
          <div class="h-4 w-full bg-gray-200 rounded"></div>
          <div class="h-4 w-5/6 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
    <div *ngIf="loading" class="p-6 border-l border-gray-200 space-y-12">
      <div class="relative">
        <div
          class="absolute left-3 top-0 h-full border-l-2 border-gray-200"
        ></div>
        <div class="relative pl-10 sm:pl-16 space-y-2">
          <div
            class="absolute left-0 top-0 w-8 h-8 rounded-full bg-gray-300"
          ></div>
          <div class="h-4 w-32 bg-gray-200 rounded mt-1"></div>
          <div class="h-3 w-full bg-gray-300 rounded mt-1"></div>
        </div>
        <div class="relative pl-10 sm:pl-16 space-y-2">
          <div
            class="absolute left-0 top-0 w-8 h-8 rounded-full bg-gray-300"
          ></div>
          <div class="h-4 w-28 bg-gray-200 rounded mt-1"></div>
          <div class="h-3 w-full bg-gray-300 rounded mt-1"></div>
        </div>
        <div class="relative pl-10 sm:pl-16 space-y-2">
          <div
            class="absolute left-0 top-0 w-8 h-8 rounded-full bg-gray-300"
          ></div>
          <div class="h-4 w-36 bg-gray-200 rounded mt-1"></div>
          <div class="h-3 w-5/6 bg-gray-300 rounded mt-1"></div>
        </div>
      </div>
    </div>
  </section>
</div>
